import { computed, type ComputedRef } from 'vue'

import { isHardGateBilling20516Active } from '@/models/hardGateBilling20516'

/**
 * `isHardGateBilling20516Active()` for templates.
 *
 * The check reads `trial_start` on the stored user. Cancel leaves that
 * set, so a free account that already started a trial is not gated.
 * Trial start leaves billing, and the next page mounts a new header.
 */
export function useHardGateBilling20516Active(): ComputedRef<boolean> {
  return computed(() => isHardGateBilling20516Active())
}
